{
  "ai.title": "Inteligencia artificial",
  "ai.generate": "Generar con IA"
}
